import Box from '../components/Layout/Wrappers/Box';

const EmployerPendingsUI = {
  MessageEmployerToCandidate: {
    Icon: {
      info: (
        <Box row style={{ maxWidth: 512 }}>
          The last message you sent to a candidate is pre-loaded. If it was a template, the template is preloaded. If you sent a hand modified message, then that message is loaded unchanged. Review and update if necessary for the current candidate.
        </Box>
      )
    },
    WarningChipMessage: {
      note: 'NOTE - This is the last message sent by you'
    }
  },
  middlePanelCardTitleAcceptance: 'Next step',
  middlePanelCardHeaderOneAcceptance: 'Current status',
  middlePanelCardHeaderTwoAcceptance: 'Why Yes?',
  middlePanelActionYes: 'Like',
  middlePanelActionYesInterview: 'Yes - interview!',
  middlePanelInputPlaceholder: 'Please let us know the latest status',
  middlePanelInputPlaceholderYes: 'Share why you liked the candidate, along with current status and next steps',
  middlePanelInputPlaceholderNo: `Share why rejection to help recruiters filter future submissions`,
  middlePanelInputActionFeedbackTo10x10Only: {
    actionLabel: 'Notify 10 By 10',
    actionCompleted: 'Sent to 10 By 10',
  },
  middlePanelInputActionFeedbackToRecruiterOnly: {
    actionLabel: 'Notify Recruiter',
    actionCompleted: 'Sent to Recruiter',
  },
  urlGeneratorDialog: {
    title: 'Employer portal: generate and copy URL',
    acceptLabel: 'Generate & copy URL',
    warningNoAccountsFound: 'No accounts configured',
    unexpectedError: 'The url could not be generated'
  },
  TriggerWaitingEmployerSummary: {
    IconButton: {
      tooltip: 'Generate todos summary',
      loadingTooltip: 'Generating todos summary...'
    },
    MenuItem: {
      title: 'Employer portal: generate todos summary',
    },
    Dialog: {
      title: 'Employer portal: generate todos summary',
      acceptLabel: 'Generate & copy summary',
    }
  }
};
export default EmployerPendingsUI;
